import React from 'react';
import AnimatedSection from './AnimatedSection';

const Experience = () => {
  const experiences = [
    {
      period: "Oct/2025 - Jan/2026",
      title: "Data Migration Assistans(Projekt)",
      company: "StrongPoint",
      location: "Grums",
      description: "Migrerade butikssystemdata till onlineplattformar och säkerställde korrekt och överföring. Testade funktioner efter migrering och rapporterade tekniska avvikelse"
    },
    {
      period: "2023 - Nuvarande",
      title: "Matkurir - Food Courier",
      company: "Foodora",
      location: "Arvika, Karlstad",
      description: "Leverans av mat till kunder med fokus på effektivitet och kundnöjdhet."
    },
    {
      period: "2024", 
      title: "Säljare",
      company: "Guldfynd",
      location: "Charlottenberg, Karlstad",
      description: "Försäljning av smycken och kundservice i högt tempo miljö."
    },
    {
      period: "2019 - 2023",
      title: "Skiftledare", 
      company: "McDonalds",
      location: "Arvika, Charlottenberg, Karlstad",
      description: "Personalansvar, kassaansvar och drift av restaurang. Utvecklat starka ledarskapsfärdigheter."
    },
    {
      period: "2022",
      title: "Kundtjänst",
      company: "Säkra larm",
      location: "Arvika",
      description: "Teknisk support och kundservice för larmsystem, problemlösning och kundhantering."
    },
    {
      period: "2021",
      title: "Truckförare & Montör",
      company: "Arvika Gjutare & Volvo CE",
      location: "Arvika",
      description: "Lagerhantering, intern transport och montering av tunga maskinkomponenter."
    }
  ];

  return (
    <AnimatedSection id="experience" className="section section-dark">
      <div className="container">
        <h2>Arbetslivserfarenhet</h2>
        <div className="timeline">
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-dot"></div>
              <div className="timeline-content">
                <div className="timeline-date">{exp.period}</div>
                <h3 className="timeline-title">{exp.title}</h3>
                <h4 className="timeline-company">{exp.company} • {exp.location}</h4>
                <p className="timeline-description">{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </AnimatedSection>
  );
};

export default Experience;